// common business logic related util methods
import axios from "axios";
import { useSnackbar } from "notistack";
import { baseUrl } from "src/config/config";

// ------------------------------------
// Network status listener helper
// ------------------------------------
export function setupNetworkListener() {
  const { enqueueSnackbar } = useSnackbar();
  const handleOffline = () => {
    enqueueSnackbar("Waiting for an active internet connection...", {
      variant: "warning",
    });
  };

  const handleOnline = () => {
    enqueueSnackbar("Internet connection restored", {
      variant: "success",
    });
  };

  window.addEventListener("offline", handleOffline);
  window.addEventListener("online", handleOnline);

  // cleanup function
  return () => {
    window.removeEventListener("offline", handleOffline);
    window.removeEventListener("online", handleOnline);
  };
}

export async function invokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
  enqueueSnackbar,
}) {
  // internet check before request
  if (!navigator.onLine) {
    enqueueSnackbar?.("Waiting for an active internet connection...", {
      variant: "warning",
    });

    return {
      code: 0,
      message: "No internet connection",
    };
  }
  const reqObj = {
    method,
    url: baseUrl + path,
    headers: { ...headers },
  };

  reqObj.params = queryParams;

  if (method === "POST" || method === "PUT" || method === "DELETE") {
    reqObj.data = postData;

    const isFormData =
      postData instanceof FormData ||
      postData instanceof URLSearchParams;

    if (!isFormData && reqObj.data && typeof reqObj.data === "object") {
      reqObj.headers["Content-Type"] =
        reqObj.headers["Content-Type"] || "application/json";
    }
  }

  let results;

  try {
    results = await axios(reqObj);

    return results.data;
  } catch (error) {
    // network request failed
    if (!error.response) {
      enqueueSnackbar?.("Waiting for an active internet connection...", {
        variant: "warning",
      });

      return {
        code: 0,
        message: "Network error",
      };
    }

    if (error.response.status === 401) {
      localStorage.clear();
      window.location.reload();
    }
    return {
      code: error.response.status,
      message: error.response.data.message ? error.response.data.message : "",
    };
  }
}
